<template>
  <b-card>
    <b-row>
      <b-col
        md="12"
        class="mb-2"
      >
        <b-button
          variant="secondary"
          class="float-right"
          size="sm"
          @click="query"
        >
          <feather-icon
            icon="SearchIcon"
            size="18"
            class="mr-50"
          />
          Consultar
        </b-button>
      </b-col>
      <b-col md="12">
        <b-table
          class="position-relative"
          small
          responsive
          show-empty
          :fields="fields"
          :items="items"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle" />
              <strong>Cargando...</strong>
            </div>
          </template>
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="`${
                data.item.status_p2p
                  ? data.item.status_p2p.class
                  : ''
              }`"
            >
              {{ data.item.status_p2p.estado }}
            </b-badge>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCol,
  BRow,
  BSpinner,
  BTable,
} from "bootstrap-vue"

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BButton,
    BBadge,
    BSpinner,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      isBusy: false,
      items: [],
      fields: [
        { key: "index", label: "No." },
        { key: "fechaserver", label: "Fecha" },
        { key: "balance_pesos", label: "Balance" },
        { key: "status", label: "Estado" },
        { key: "message", label: "Mensaje" },
        { key: "request_id", label: "Autorización" },
      ],
    }
  },
  created() {
    this.query()
  },
  methods: {
    query() {
      this.isBusy = true
      this.$http
        .get("/payment", {
          params: {
            idusuario: this.userData.id,
            status: "NOT-PENDING",
          },
        })
        .then((response) => {
          this.isBusy = false
          this.items = response.data.data
        })
        .catch((error) => {
          this.isBusy = false
          console.log(error)
        })
    },
  },
}
</script>
